export default class Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        return true;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration) {}
}
